<template>
  <div :class="classModifiers">
    <div class="account-ssn-info-upload__icon">
      <img src="@/assets/icons/identity.svg" />
    </div>
    <p class="account-ssn-info-upload__note">
      In order to process a credit card deposit, we need to verify your identity. This will be
      quick. Please click the button below.
    </p>
    <button
      class="button button--large button--primary button--full-width"
      @click.prevent="onButtonClick"
    >
      Verify Identity
    </button>
  </div>
</template>

<script src="./account-ssn-info-upload.js"></script>
<style src="./account-ssn-info-upload.scss" lang="scss"></style>
